import { render, staticRenderFns } from "./CardPeople.vue?vue&type=template&id=fc59a7a2&"
import script from "./CardPeople.vue?vue&type=script&lang=js&"
export * from "./CardPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports